var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.providerProps)?_c(_vm.providerProps.provider,{tag:"component",attrs:{"value":_vm.providerProps.props}},[_c('router-view',[_vm._t("default")],2)],1):_c('router-view',{attrs:{"name":"default"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }